import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

import { ERROR_TYPE, getErrorMessage, translateError } from "@/utils/errors";

/**
 * The sentence to show when activating or pausing a campaign is refused (PREC-4320).
 *
 * The campaigns table used to swallow the refusal: `rtkRejectQueryMiddleware` handles rejected
 * *queries* only, so a rejected mutation reached nobody, and a campaign whose end date had passed
 * just did not start. The API answers with a code (`CAMPAIGN_END_DATE_PASSED`, …), which is
 * translated here, and anything the table has no sentence for falls back to the generic one.
 */
export const campaignStatusErrorText = (
	error: FetchBaseQueryError | SerializedError | undefined
): string => {
	const code = error ? getErrorMessage(error) : ERROR_TYPE.SOMETHING_WRONG;

	return translateError[code] ?? translateError[ERROR_TYPE.SOMETHING_WRONG];
};
